import React from 'react';
import './footer.css';
import { footer } from "../../modules/data";

const genitemf0=()=>{
    const idata=footer[0]
    const content0= 
       
            <h1>{idata['title']} </h1>
           
    const content1=
        <div> 
            
            <div>
            {idata['i'].map((item,index)=>(
            <a key={index} href={idata['href'][index]}>{item}</a>))}


            </div>

            <ul>
                {idata['li'].map((item,index)=>(
                    <li key={index}><a href={idata['a'][index]}>{item}</a></li>
                    ))}
            </ul>
       
            
        </div>
        
      

    return(
        [ content0,content1] 
        
    )
}
const   Footer = () => {
  
    const item=genitemf0()
    const content0=item[0]
    const content1=item[1]
    return (
        <div className="footer" >

            <div className="container" >

                <section className="row0">
                    {content0}
                </section>

                <section className="row1">
                    {content1}
                </section>


            </div>
        </div>
    );
    

}

export default Footer;